/**
 * Generate a unique ID for a canvas element
 * @returns
 */
export const generateCanvasId = () => {
  // Get the current timestamp in milliseconds
  const timestamp = Date.now().toString(36);

  // Generate a random string with base 36 (0-9, a-z) and slice to 4 characters
  const randomString = Math.random().toString(36).substring(2, 8);

  // Combine the timestamp and random string
  const shortUniqueId = `${timestamp}-${randomString}`;

  return shortUniqueId;
};
